import { Directive, inject, computed, input } from '@angular/core';
import { FormField, NgValidationError } from '@angular/forms/signals';

@Directive({
  selector: '[nttInput]',

  host: {
    class: 'ntt-form-field__input',
    '[attr.disabled]': 'isDisabled() ? "" : null',
    '[attr.aria-invalid]': 'shouldShowErrors()',
    '[class.ntt-form-field__input--placeholder-rtl]':
      'placeholderDirection() === "rtl"',
  },
})
export class NttInput {
  readonly field = inject(FormField, { optional: true, self: true });

  readonly placeholderDirection = input<'ltr' | 'rtl'>('rtl');

  readonly state = computed(() => this.field?.state());

  readonly isDisabled = computed(() => {
    return this.state()?.disabled() ?? false;
  });

  readonly isInvalid = computed(() => {
    return this.state()?.invalid() ?? false;
  });

  readonly isTouched = computed(() => {
    return this.state()?.touched() ?? false;
  });

  readonly isSubmitting = computed(() => {
    return this.state()?.submitting() ?? false;
  });

  readonly shouldShowErrors = computed(() => {
    return this.isInvalid() && this.isTouched();
  });

  readonly errors = computed(() => {
    if (!this.shouldShowErrors()) return [];
    return (this.state()?.errors() as NgValidationError[]) ?? [];
  });
}
